import React from 'react'
import Swal from 'sweetalert2'
import Constant from '../../Constant.js'
import axios from 'axios'
import MUIDataTable from 'mui-datatables'
import Select from 'react-select'

class CruiseIdReport extends React.Component {
  state = {
    list: [],
    isLoading: false,
    categoryId: null,
    categoryList: [],
  }

  componentDidMount() {
    this.loadReport()
    this.getCategoryList()
  }

  loadReport = async () => {
    this.setState({
      isLoading: true,
      list: [],
    })

    const catID = this.state.categoryId?.value || ''

    await axios
      .post(
        Constant.getAPI() + `/reports/cruise-id-report?categoryId=${catID}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        }
      )
      .then((response) => {
        this.setState({
          list: response?.data?.data?.data,
        })
      })
      .catch((err) => {
        Swal.fire({
          title: err?.response?.data?.data,
          icon: 'error',
          text: '',
          type: 'error',
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ok',
        })
      })
      .finally(() => {
        this.setState({ isLoading: false })
      })
  }

  handleClear = () => {
    this.setState({ categoryId: null, list: [] }, () => {
      this.loadReport()
    })
  }

  handleCategoryChange = (event) => {
    this.setState({
      categoryId: event,
    })
  }

  clearSearch = async () => {
    this.setState({
      categoryId: null,
      list: [],
    })
  }

  getCategoryList = async () => {
    await axios
      .get(Constant.getAPI() + '/cruise/list-cruise-masters?type=cruise&is_active=true', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({
            categoryList: Array.isArray(res.data.data)
              ? [
                  { label: 'All', value: '' },
                  ...res.data.data.map((ele) => ({
                    label: `${ele.cruise_cat_en}/${ele.cruise_cat_ar}`,
                    value: ele.id,
                  })),
                ]
              : [{ label: 'All', value: '' }],
          })
        }
      })
  }

  render() {
    const columns = [
      {
        name: 'id',
        label: 'Cruise ID',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'cruise_captain_id',
        label: 'Captain ID',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'cruise_owner_admin_owner_id',
        label: 'Owner ID',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'cruise_name_en',
        label: 'Name(EN)',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'cruise_name_ar',
        label: 'Name(AR)',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'cruise_type',
        label: 'Cruise Type',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'country',
        label: 'Country',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'is_active',
        label: 'Status',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value == true ? 'ACTIVE' : 'INACTIVE'),
        },
      },
    ]

    const options = {
      filterType: 'dropdown',
      viewColumns: false,
      print: false,
      download: true,
      selectableRows: 'none',
      filter: false,
      textLabels: {
        body: {
          noMatch: this.state.isLoading ? 'Loading data..!' : 'Sorry, No data Found',
          toolTip: 'Sort',
          columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        },
      },
    }

    return (
      <div className="pcoded-inner-content">
        <div className="main-body">
          <div className="page-wrapper">
            <div className="page-body">
              <div className="row">
                <div className="col-sm-12">
                  <div className="card card-border-default">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Category</label>
                            <div className="col-sm-9">
                              <Select
                                name="categoryId"
                                value={this.state.categoryId}
                                onChange={this.handleCategoryChange}
                                options={this.state.categoryList}
                                isMulti={false}
                                isSearchable={true}
                                isClearable
                                onClear={this.handleClear}
                                placeholder="Select Options"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="row">
                            <div className="text-right col-12">
                              {this.state.isLoading ? (
                                <button
                                  className="btn btn-grd-disabled"
                                  disabled
                                  style={{ width: 150 }}
                                >
                                  Searching...!
                                </button>
                              ) : (
                                <>
                                  <button
                                    style={{ width: 150 }}
                                    className="btn btn-inverse waves-effect m-r-10"
                                    onClick={this.clearSearch}
                                  >
                                    Clear
                                  </button>
                                  <button
                                    style={{ width: 150 }}
                                    onClick={this.loadReport}
                                    className="btn btn-inverse waves-effect"
                                  >
                                    Search
                                  </button>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="card">
              <div className="dt-responsive table-responsive">
                <MUIDataTable
                  title={'Cruise List Report'}
                  className="table-responsive"
                  data={this.state.list}
                  columns={columns}
                  options={options}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default CruiseIdReport
